import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { LsbApi, type PostInquiryRequest } from '@shared/api';

const postInquiryEffect = createEffect((request: PostInquiryRequest) => LsbApi.postInquiry(request));
const clearEvent = createEvent();

const $dataStore = createStore<boolean | null>(null)
  .on(postInquiryEffect.done, (_, data) => data.result.success || false)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(postInquiryEffect.pending, (_, data) => data)
  .on(postInquiryEffect.fail, () => false)
  .on(postInquiryEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(postInquiryEffect, () => null)
  .on(
    postInquiryEffect.fail,
    (_, data) => ApiUtils.getApiErrorData(data.error, 'Something went wrong while submitting Request. Please try again.').message,
  )
  .on(postInquiryEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

export const $postInquiryStore = {
  events: {
    postInquiry: postInquiryEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
